/**
 * TradesCheckboxGroup
 * The trade multi-select shared by the Add/Edit Vendor form (SettingsVendorsPage) and the
 * "Add a new vendor" step of the email link dialog (NewVendorForm), so both offer the same
 * trade options.
 */

export const REPAIR_CATEGORIES = [
  'plumbing',
  'electrical',
  'hvac',
  'appliance',
  'structural',
  'general',
] as const;

export type RepairCategory = (typeof REPAIR_CATEGORIES)[number];

interface TradesCheckboxGroupProps {
  selected: string[];
  onChange: (trades: string[]) => void;
  /** Prefix for per-trade data-testids: `${testIdPrefix}-${trade}`. */
  testIdPrefix?: string;
}

export function TradesCheckboxGroup({
  selected,
  onChange,
  testIdPrefix = 'vendor-trade',
}: TradesCheckboxGroupProps): JSX.Element {
  function toggle(trade: RepairCategory): void {
    if (selected.includes(trade)) {
      onChange(selected.filter((t) => t !== trade));
    } else {
      onChange([...selected, trade]);
    }
  }
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-1" role="group" aria-label="Trades">
      {REPAIR_CATEGORIES.map((cat) => (
        <label
          key={cat}
          className="flex items-center gap-1.5 text-sm cursor-pointer select-none min-h-[44px]"
        >
          <input
            type="checkbox"
            value={cat}
            checked={selected.includes(cat)}
            onChange={() => toggle(cat)}
            className="rounded"
            aria-label={cat}
            data-testid={`${testIdPrefix}-${cat}`}
          />
          <span className={cat === 'hvac' ? undefined : 'capitalize'}>{cat === 'hvac' ? 'HVAC' : cat}</span>
        </label>
      ))}
    </div>
  );
}
